import { type FormEvent, useState } from 'react';
import { Link } from 'react-router';
import { useApi } from '@plataforma/web/api';
import { fechaCorta } from '@plataforma/web/formato';

const TIPOS: [string, string, string][] = [
  ['acceso', 'Acceso', 'Quiero saber qué datos personales míos tienen y para qué los usan.'],
  ['rectificacion', 'Rectificación', 'Algún dato mío está mal y quiero corregirlo.'],
  ['cancelacion', 'Cancelación', 'Quiero que borren mis datos personales (supresión).'],
  ['oposicion', 'Oposición', 'No quiero que usen mis datos para cierta finalidad.'],
  ['revocacion', 'Revocación', 'Retiro mi consentimiento (por ejemplo, para publicidad).'],
];

/** Mis derechos ARCO (arquitectura 2.12): la solicitud se vuelve un ticket con su plazo. */
export function MiPrivacidad() {
  const api = useApi();
  const [hecho, setHecho] = useState<{ folio: string; venceEn: string } | null>(null);
  const [error, setError] = useState<string | null>(null);
  const enviar = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const d = new FormData(e.currentTarget);
    setError(null);
    try {
      setHecho(
        await api('POST', '/platform/mi-lotero/arco', {
          tipo: String(d.get('tipo') ?? ''),
          ...(d.get('detalle') && { detalle: String(d.get('detalle')) }),
        }),
      );
    } catch (err) {
      setError((err as Error).message);
    }
  };
  return (
    <>
      <div className="encabezado">
        <div>
          <h1>Mi privacidad</h1>
          <div className="subtitulo">
            Tus derechos de acceso, rectificación, cancelación y oposición (ARCO) sobre tus datos
            personales.
          </div>
        </div>
      </div>
      {hecho ? (
        <section className="seccion cuerpo">
          <p className="etiqueta exito">Recibimos tu solicitud {hecho.folio}.</p>
          <p>
            Te pediremos confirmar tu identidad y te responderemos a más tardar el{' '}
            {fechaCorta(hecho.venceEn)}. Puedes seguirla en <Link to="/ayuda/tickets">Soporte</Link>
            .
          </p>
        </section>
      ) : (
        <form className="seccion cuerpo formulario" onSubmit={(e) => void enviar(e)}>
          <fieldset
            style={{ border: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 8 }}
          >
            {TIPOS.map(([v, t, ayuda], i) => (
              <label key={v} style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
                <input type="radio" name="tipo" value={v} required defaultChecked={i === 0} />
                <span>
                  <strong>{t}</strong>
                  <br />
                  <small className="subtitulo">{ayuda}</small>
                </span>
              </label>
            ))}
          </fieldset>
          <label className="campo">
            <span>Detalle (opcional)</span>
            <textarea name="detalle" rows={4} maxLength={5000} />
          </label>
          <p className="subtitulo">
            Si pides la cancelación y eres el único dueño de tu lotero, primero hay que dar de baja
            el lotero o pasar la cuenta a otra persona.
          </p>
          {error && <p className="error">{error}</p>}
          <div>
            <button className="boton primario">Enviar solicitud</button>
          </div>
        </form>
      )}
    </>
  );
}
